import moment from 'moment';
import 'moment/locale/ru';

// Устанавливаем глобальную локаль moment:
// 1) из настроек app_date_locale, 2) из lang страницы, 3) fallback ru
var htmlLang = document.documentElement.lang || 'ru';
var dateLoc = (window.app && window.app.app_date_locale) ? window.app.app_date_locale : htmlLang;
moment.locale(dateLoc);

window.moment = moment;
